import * as React from 'react';
import type { SVGProps } from 'react';
import { Ref, forwardRef, memo } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
const SvgLoaderPinwheel = (
  {
    title,
    titleId,
    desc,
    descId,
    ...props
  }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    role="img"
    ref={ref}
    aria-labelledby={titleId}
    aria-describedby={descId}
    {...props}
  >
    {desc ? <desc id={descId}>{desc}</desc> : null}
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M2.757 7.757A6 6 0 0 1 13 12a4 4 0 1 0 8 0 1 1 0 1 1 2 0 6 6 0 1 1-12 0 4 4 0 1 0-8 0 1 1 0 1 1-2 0 6 6 0 0 1 1.757-4.243"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.137 2.897a1 1 0 0 1 1.367-.362 5.973 5.973 0 0 1-6.003 10.33A4.017 4.017 0 0 0 7.5 19.834a1 1 0 1 1-.997 1.734A6.017 6.017 0 0 1 12.5 11.133l.004.002a3.975 3.975 0 0 0 3.995-6.87 1 1 0 0 1-.362-1.368"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.517 3.758a3.97 3.97 0 0 0-3.014.406 1 1 0 1 1-1.005-1.729 5.974 5.974 0 1 1 6.005 10.33 3.974 3.974 0 0 0 3.994 6.87 1 1 0 0 1 1.006 1.73 5.974 5.974 0 1 1-6.005-10.33 3.974 3.974 0 0 0-.98-7.277"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgLoaderPinwheel);
const Memo = memo(ForwardRef);
export default Memo;
